import { render } from "./GanttChartTime.vue?vue&type=template&id=b9b96844&scoped=true"
import script from "./GanttChartTime.vue?vue&type=script&lang=js"
export * from "./GanttChartTime.vue?vue&type=script&lang=js"

import "./GanttChartTime.vue?vue&type=style&index=0&id=b9b96844&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9b96844"]])

export default __exports__